import { request } from '../lib/request';
import { PaymentMethods } from '../types';

export const loadBoundCardsApi = async (apiHost: string, serviceToken?: string, loadSbpTokens?: boolean) => {
    let params;

    if (loadSbpTokens) {
        params = {
            show_sbp_tokens: 'true',
        };
    }

    const data = await request<PaymentMethods>({
        method: 'GET',
        url: `${apiHost}/web/payment_methods`,
        headers: serviceToken ? { 'X-Service-Token': serviceToken } : undefined,
        params,
    });

    const methods = data.payment_methods;

    return Object.keys(methods)
        .filter((id) => id.startsWith('card') || id.startsWith('sbp'))
        .map((id) => ({
            ...methods[id]!,
            method_id: methods[id]!.id,
            id,
        }));
};
